import { Vector2Tuple } from 'three';

import { FPolygonShallowNode } from '@spazious/dollhouse-shallow-graph';

import { FArrangement } from '../farrangements/index.js';
import { FNodeTypesEnum, FPolygonNode } from '../types/index.js';

import { BaseNodeImpl } from './BaseNode.js';

export class FPolygonNodeImpl extends BaseNodeImpl implements FPolygonNode {
  type: FNodeTypesEnum.FPolygon = FNodeTypesEnum.FPolygon;
  shallow: FPolygonShallowNode | null = null;
  id: number = 0;
  points: Vector2Tuple[] = [];
  position: Vector2Tuple = [0, 0];
  instance!: FArrangement;
  rotation: number = 0;
  visible: boolean = true;
  toJSON(recursive?: boolean) {
    return {
      ...super.toJSON(recursive),
      id: this.id,
      position: this.position,
      rotation: this.rotation,
      instance: this.instance?.toJSON(),
      visible: this.visible,
      shallow: this.shallow,
      points: this.points,
    };
  }
}
